import {
  View,
  Text,
  ScrollView,
  Image,
  ActivityIndicator,
  FlatList,
  TouchableWithoutFeedback,
  TouchableOpacity,
} from "react-native";
import React, { useEffect, useState } from "react";
import { LinearGradient } from "expo-linear-gradient";
import { AppColors } from "../../utility/AppColors";
import { s } from "react-native-size-matters";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { CommonButton } from "../../common/CommonButton";
import { AppImages } from "../../utility/AppImages";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppScreens } from "../Utility/AppScreens";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../utility/NavigationHelper";
import SearchComponent from "../../Components/choose-game-components/SearchComponent";
import GameComponent from "../../Components/choose-game-components/GameComponent";
import { getLoginData, storeLoginData } from "../../utility/AppStoreData";
import { base_url, endpoints } from "../../Api/configs";
import { toast } from "react-toastify";
import { ShowLoader } from "../../common/ShowLoader";
import { getUserProfile, login } from "../../services/authAPI";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { fetchGenreGames, updateUserGames } from "../../services/authAPI";
import ImageComponent from "../../Components/ImageComponent";
import { getUserLocationDetails } from "../../common/getLocation";
import ChooseGameLikeScreenSkeleton from "../../Components/skeleton-components/ChooseGameLikeSkeleton";
import { ScreenBGGradientView } from "../../common/CommonView";

const ChooseGameLikeScreen = ({ route }) => {
  const routeData = route.params;
  const username = routeData?.username;
  const flag = routeData?.flag;
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [genreGames, setGenreGames] = useState([]);
  const [selectedGames, setSelectedGames] = useState([]);
  const [filteredGames, setFilteredGames] = useState([]);
  const navigation = useNavigation();
  const [searchEvent, setSearchEvent] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [showUpdateGamesLoader, setShowUpdateGamesLoader] = useState(false);
  const [myGames, setMyGames] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const getGenreGames = async () => {
    setShowLoader(true);

    try {
      const response = await fetchGenreGames();
      const responseBody =
        typeof response.body === "string"
          ? JSON.parse(response.body)
          : response.body;

      if (response.statusCode === 200) {
        setGenreGames(responseBody);
        setFilteredGames(responseBody);
      } else {
        toast.error(responseBody.error);
      }
      setShowLoader(false);
    } catch (error) {
      setShowLoader(false);
      console.error("get games API Error:- ", error.message);
      toast.error(error.message);
    }
  };
  const userProfileAPI = async (AccessToken?: string) => {
    setShowLoader(true);

    try {
      const data = await getUserProfile(AccessToken);
      const responseBody =
        typeof data.body === "string" ? JSON.parse(data.body) : data.body;

      setShowLoader(false);

      if (data.statusCode === 200) {
        setMyGames(responseBody?.myGames || []);
        setSelectedGames(responseBody?.selectedGames || []);
      } else if (data.statusCode == 400) {
        toast.error("Bad Request");
      } else if (data.statusCode > 400 && data.statusCode < 420) {
        toast.error("Unauthorized");
      } else if (data.statusCode >= 500) {
        toast.error("Internal Server Error");
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (routeData.flag) {
          const loginData = await getLoginData();
          await userProfileAPI(loginData.AccessToken);
          await getGenreGames();
        } else {
          await getGenreGames();
        }
      } catch (error) {
        console.error("Error in fetchData:", error);
      }
    };

    fetchData();
  }, [routeData]);

  const loginApi = async () => {
    try {
      setShowLoader(true);

      const existingLoginData = await getLoginData();
      if (existingLoginData) {
        navigateToScreen(navigation, AppScreens.DrawerRoute, {
          username: username,
          showWelcome: true,
        });
        setShowLoader(false);
        return;
      }

      const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2)
          return decodeURIComponent(parts.pop().split(";").shift());
        return null;
      };

      const password = getCookie("password");

      // Log for debugging
      console.log("ChooseGameLikeScreen loginApi - username:", username);
      console.log("ChooseGameLikeScreen loginApi - password from cookie:", password ? "***SET***" : "NULL");

      // Check if password cookie is available
      if (!password) {
        console.error("Password cookie is null! Cookie may not have been set during registration.");
        toast.error("Session expired. Please login manually.");
        navigateToScreen(navigation, AppScreens.LoginWebScreen);
        setShowLoader(false);
        return;
      }

      const params = {
        username: username,
        password: password,
      };

      const data = await login(params);

      if (data.status === 200) {
        toast.success("Login successful");
        storeLoginData(data.body);
        await AsyncStorage.setItem("username", username);
        await getUserLocationDetails();
        document.cookie = "password=; path=/; max-age=0;";

        navigateToScreen(navigation, AppScreens.DrawerRoute, {
          username: username,
          showWelcome: true, // Flag to show welcome popup
        });
      } else {
        toast.error("Login failed");
      }
    } catch (error) {
      console.log("Login error:", error);
      toast.error(error.message || "Login failed");
    } finally {
      setShowLoader(false);
    }
  };

  const callUpdateGamesAPI = async () => {
    setShowUpdateGamesLoader(true);

    const params = {
      username: username,
      selectedGames: selectedGames,
    };

    try {
      const response = await updateUserGames(params);
      const responseBody =
        typeof response.body === "string"
          ? JSON.parse(response.body)
          : response.body;

      setShowUpdateGamesLoader(false);
      if (response.statusCode === 200) {
        toast.success("Games updated successfully");
        const data = await getLoginData();
        if (!data) {
          await loginApi();
        } else {
          await getUserLocationDetails();
          if (flag === 1) {
            navigation.dispatch(StackActions.pop());
          } else {
            navigateToScreen(navigation, AppScreens.DrawerRoute, {
              username: username,
              showWelcome: true,
            });
          }
        }
      } else {
        toast.error(responseBody.error);
      }
    } catch (error) {
      console.error("Update games API Error:- ", error.message);
      toast.error(error.message);
      setShowUpdateGamesLoader(false);
    }
  };
  const groupedGames = [];
  for (let i = 0; i < filteredGames.length; i += 10) {
    groupedGames.push(filteredGames.slice(i, i + 10));
  }
  return (
    <TouchableWithoutFeedback
      onPress={() => {
        setShowSuggestions(false);
      }}
    >
      <View style={styles.container}>
        <ScreenBGGradientView />

        {showLoader ? (
          <ChooseGameLikeScreenSkeleton />
        ) : (
          <View
            style={{
              paddingHorizontal:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? s(8)
                  : s(8),
              paddingTop:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? s(8)
                  : s(8),
              flex: 1,
              justifyContent: "space-between",
            }}
          >
            <View style={styles.headerContainer}>
              <Text
                style={[
                  deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.BOLD_ANYBODY_24
                    : AppFontStyle.BOLD_ANYBODY_40,
                  {
                    color: AppColors.white,
                  },
                ]}
              >
                {"Set your Profile"}
              </Text>
              <Image
                source={AppImages.KO_LOGO_Main}
                style={styles.koLogo}
                resizeMode="contain"
              />
            </View>
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_15,
                {
                  color: AppColors.white,
                  marginBottom:
                    deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                      ? 15
                      : 18,
                  fontWeight: 800,
                  marginLeft: 3,
                },
              ]}
            >
              {"Choose Games You Like"}
            </Text>
            <SearchComponent
              styles={styles}
              searchEvent={searchEvent}
              setSearchEvent={setSearchEvent}
              genreGames={genreGames}
              setFilteredGames={setFilteredGames}
              showSuggestions={showSuggestions}
              setShowSuggestions={setShowSuggestions}
            />
            <ScrollView
              contentContainerStyle={styles.gridContainer}
              style={styles.scrollView}
              showsVerticalScrollIndicator={false}
              showsHorizontalScrollIndicator={false}
            >
              {filteredGames.map((game, index) => (
                <GameComponent
                  key={index}
                  game={game}
                  isSelected={selectedGames.includes(game.title)}
                  onSelectionChange={(isSelected: boolean) => {
                    setSelectedGames((prevSelectedGames) => {
                      if (isSelected) {
                        return [...prevSelectedGames, game.title];
                      } else {
                        return prevSelectedGames.filter(
                          (title) => title !== game.title
                        );
                      }
                    });
                  }}
                  styles={styles}
                />
              ))}
            </ScrollView>
            <LinearGradient
              colors={["#111827", "#000000"]}
              start={[0, 0]}
              end={[0, 1]}
              style={styles.buttonContainer}
            >
              <CommonButton
                title="Skip"
                onTap={async () => {
                  await loginApi();
                }}
                buttonStyle={{
                  paddingVertical: 10,
                  paddingHorizontal: 24,
                  backgroundColor: "transparent",
                  borderRadius: 6,
                  borderWidth: 1,
                  borderColor: AppColors.white,
                  height: 40,
                }}
              />

              <TouchableOpacity
                onPress={async () => {
                  if (!showUpdateGamesLoader) {
                    await callUpdateGamesAPI();
                  }
                }}
                disabled={showUpdateGamesLoader}
                style={{
                  paddingVertical: 10,
                  paddingHorizontal: 24,
                  backgroundColor: "#DC2626",
                  borderRadius: 6,
                  width: 158,
                  height: 40,
                  justifyContent: "center",
                  alignItems: "center",
                  opacity: showUpdateGamesLoader ? 0.7 : 1,
                }}
              >
                {showUpdateGamesLoader ? (
                  <ActivityIndicator size="small" color={AppColors.white} />
                ) : (
                  <Text style={[AppFontStyle.BOLD_ANYBODY_14, { color: AppColors.white }]}>
                    Continue
                  </Text>
                )}
              </TouchableOpacity>
            </LinearGradient>
          </View>
        )}
      </View>
    </TouchableWithoutFeedback>
  );
};

export default ChooseGameLikeScreen;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      flexDirection: "row",
    },
    headerContainer: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 8,
    },
    koLogo: {
      width: 183,
      height: 99.408,
      flexShrink: 0,
    },
    buttonContainer: {
      marginTop: s(8),
      marginBottom: s(8),
      flexDirection: "row",
      gap: s(10),
      justifyContent: "space-between",
      alignItems: "center",
      padding: 18,
      borderRadius: 12,
    },
    gridContainer: {
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      paddingHorizontal: 2,
      paddingVertical: 10,
      gap: 15,
    },
    scrollView: {
      height: 204,
    },
    loaderContainer: {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      justifyContent: "center",
      alignItems: "center",
      zIndex: 10, // Ensure the loader is on top
    },
    shodowBottom: {
      height: "40%",
      width: "30%",
      position: "absolute",
      resizeMode: "stretch",
      bottom: 0,
    },
    shodowTopRight: {
      width: 820,
      height: 546,
      position: "absolute",
      resizeMode: "stretch",
      top: 0,
      right: 0,
      flexShrink: 0,
    },
    serachBtn: {
      width: 24,
      height: 24,
    },
    item: {
      flex: 1,
      borderRadius: 10,
      borderWidth: 5,
      borderColor: AppColors.white,
      elevation: s(2),
      gap: 0,
    },
    searchTextStyle: {
      maxWidth: 450,
      height: 48,
      alignItems: "center",
      borderWidth: 0,
      flex: 1,
    },
    columnWrapperStyle: {
      overflow: "scroll",
      gap: s(3),
      display: "flex",
    },
    suggestionBox: {
      backgroundColor: "#1F2937",
      borderRadius: 8,
      borderWidth: 0.8,
      borderColor: "#374151",
      position: "absolute",
      top: 50,
      zIndex: 1000,
      maxWidth: 450,
      maxHeight: 200,
    },
    suggestionItem: {
      padding: 12,
      borderBottomWidth: 0.8,
      borderBottomColor: "#374151",
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      shodowBottom: {
        height: "40%",
        width: "30%",
        position: "absolute",
        resizeMode: "stretch",
      },
      searchTextStyle: {
        maxWidth: 450,
        height: 48,
        alignItems: "center",
        borderWidth: 0,
        flex: 1,
      },
      columnWrapperStyle: {
        overflow: "scroll",
      },
      gridContainer: {
        justifyContent: "center",
        gap: 20,
      },
    },
    [DEVICE_SIZES.MD]: {
      shodowBottom: {
        height: "40%",
        width: "30%",
        position: "absolute",
        resizeMode: "stretch",
      },
      searchTextStyle: {
        maxWidth: 450,
        height: 48,
        alignItems: "center",
        borderWidth: 0,
        flex: 1,
      },
      columnWrapperStyle: {
        overflow: "scroll",
      },
      gridContainer: {
        justifyContent: "center",
        gap: 7,
      },
    },
    [DEVICE_SIZES.SM]: {
      koLogo: {
        width: 120,
        height: 65,
      },
      shodowBottom: {
        height: "40%",
        width: "30%",
        position: "absolute",
        resizeMode: "stretch",
      },
      searchTextStyle: {
        width: "100%",
        height: 48,
        alignItems: "center",
        borderWidth: 0,
        flex: 1,
      },
      columnWrapperStyle: {
        overflow: "scroll",
      },
      suggestionBox: {
        width: "100%",
      },
      gridContainer: {
        justifyContent: "space-evenly",
        gap: 5,
        paddingHorizontal: 3,
      },
    },
    [DEVICE_SIZES.XS]: {
      koLogo: {
        width: 100,
        height: 54,
      },
      shodowBottom: {
        height: "25%",
        width: "50%",
        position: "absolute",
        resizeMode: "stretch",
      },
      searchTextStyle: {
        width: "100%",
        height: 48,
        alignItems: "center",
        borderWidth: 0,
        flex: 1,
      },
      columnWrapperStyle: {
        overflow: "scroll",
      },
      shodowTopRight: {
        width: 545,
        height: 283,
      },
      suggestionBox: {
        width: "100%",
      },
      gridContainer: {
        justifyContent: "space-evenly",
        gap: 4,
        paddingHorizontal: 2,
      },
    },
  }
);
